import React, { FC, ReactNode } from 'react';
import './index.css';
import { classNames } from 'utils';

interface RadioButtonProps {
  id?: string;
  name: string;
  isChecked: boolean;
  children?: ReactNode;
  className?: string;
  onChange?: (id: string, checked: boolean) => void;
  onClick?: (id: string, checked: boolean) => void;
  isDisabled?: boolean;
}

const RadioButton: FC<RadioButtonProps> = ({
  children,
  name,
  className,
  onChange,
  onClick,
  id,
  isChecked = false,
  isDisabled = false,
}) => {
  const compId = id || `radio-${Date.now()}`;
  const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(compId, Boolean(e.target.value));
  };
  return (
    <div className="flex items-center">
      <input
        id={compId}
        type="radio"
        name={name}
        className="hidden"
        disabled
        checked={isDisabled ? false : isChecked}
        onChange={onRadioChange}
      />
      <label
        htmlFor={compId}
        onClick={() => {
          if (onClick) onClick(compId, !isChecked);
        }}
        className={`flex items-center cursor-pointer  ${className || ''} `.trim()}
      >
        <span
          className={classNames(
            'w-4 h-4 inline-block mr-2 rounded-full border transition-all duration-200',
            isDisabled
              ? 'border-gray-300 dark:border-slate-600 opacity-50'
              : isChecked
              ? 'border-orange dark:border-teal-500 bg-orange dark:bg-teal-500'
              : 'border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 hover:border-orange/60 dark:hover:border-teal-500/60',
          )}
        />
        {children || null}
      </label>
    </div>
  );
};

export default RadioButton;
